import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import axios from "axios";
import { format } from "date-fns";
import { differenceInDays, parseISO } from "date-fns";
import { Tooltip } from "@mui/material";
import { CheckCircle, Warning, Error } from "@mui/icons-material";

const DataTable = ({ endpoint }) => {

  console.log("endpoint in DATATABLE >>>", endpoint)

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const pageSize = 20;

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits for day
    return `${year}-${month}-${day}`;
  };

  const todayDate = getTodayDate();

  useEffect(() => {
    fetchTableData();
  }, [endpoint]);

  const fetchTableData = async () => {
    try {

      let apiUrl = `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`

      console.log("apiUrl >>>", apiUrl)

      const response = await axios.get(
        // `https://cubixweberp.com:213/api/HRDashboard/SUNRISE/MAIN/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
        apiUrl

      );
      const data = response.data;
      console.log('data', response.data)
      if (endpoint === "CRM_CUSTOMER_AQUI") {
        console.log("CRM_SALESMAN_PERFORM data:", data);
      }
      setTableData(data);
    } catch (error) {
      console.error("Error while fetching table data", error);
    }
  };

  const columns =
    endpoint && endpoint === "CRM_TOP100ORDER_PRODUCTS"
      ? [
        { field: "id", headerName: "Sl No", flex: 0.3 },
        { field: "code", headerName: "Code", flex: 1 },
        { field: "desc", headerName: "Description", flex: 5 },
        { field: "totalRevenue", headerName: "Total Revenue", flex: 0.8, type: 'number' },
        { field: "totalSold", headerName: "Total Sold", flex: 0.5, type: 'number' },
      ]
      : endpoint === "CRM_CUST_LIFETIME_VALUE"
        ? [
          { field: "id", headerName: "Sl No", flex: 0.3 },
          { field: "account", headerName: "Account", flex: 1 },
          {
            field: "accountDescription",
            headerName: "Account Description",
            flex: 2,
          },
          { field: "totalSpent", headerName: "Total Spent", flex: 0.8, type: 'number' },
          { field: "totalOrders", headerName: "Total Orders", flex: 0.5, type: 'number' },
          {
            field: "avgOrderValue",
            headerName: "Average Order Value",
            flex: 1,
            type: 'number'
          },
        ]
        : endpoint === "DAILYSALES_DEPT"
          ? [
            { field: "id", headerName: "Sl No", flex: 0.3 },
            { field: "deptno", headerName: "Dept No", flex: 0.5 },
            { field: "deptnodesc", headerName: "Department Description", flex: 1.5 },
            {
              field: "SaleDate",
              headerName: "Sale Date",
              flex: 1,
              // valueGetter: (params) => new Date(params.row?.SaleDate).toLocaleDateString("en-GB"),
            },
            { field: "SalesCount", headerName: "Sales Count", flex: 0.6, type: 'number' },
            { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number' },
            { field: "AvgOrderValue", headerName: "Avg. Order Value", flex: 1, type: 'number' },
          ]

          : endpoint === "MONTHLYSALES_DEPT"
            ? [
              { field: "id", headerName: "Sl No", flex: 0.3 },
              { field: "deptno", headerName: "Dept No", flex: 0.5 },
              { field: "deptnodesc", headerName: "Department Description", flex: 1.5 },
              {
                field: "SaleMonth",
                headerName: "Sale Month",
                flex: 1,
                // valueGetter: (params) => {
                //   const [year, month] = params.row?.SaleMonth?.split("-") ?? [];
                //   return month && year ? `${month}-${year}` : "";
                // },
              },
              { field: "SalesCount", headerName: "Sales Count", flex: 0.6, type: 'number' },
              { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number' },
              { field: "AvgOrderValue", headerName: "Avg. Order Value", flex: 1, type: 'number' },
            ]

            : endpoint === "SAMAN_PERF_SUMM"
              ? [
                { field: "id", headerName: "Sl No", flex: 0.3 },
                { field: "sman_key", headerName: "Salesman Code", flex: 0.7 },
                { field: "sman_name", headerName: "Salesman Name", flex: 1.5 },
                { field: "email", headerName: "Email", flex: 1.5 },
                { field: "phoneno", headerName: "Phone Number", flex: 1 },
                { field: "SalesCount", headerName: "Sales Count", flex: 0.6, type: 'number' },
                { field: "TotalSales", headerName: "Total Sales", flex: 1, type: 'number' },
                {
                  field: "LastSaleDate",
                  headerName: "Last Sale Date",
                  flex: 1,
                  type: 'number',
                  // valueGetter: (params) =>
                  //   new Date(params.row?.LastSaleDate).toLocaleDateString("en-GB"),
                },

                { field: "AvgSaleAmount", headerName: "Avg. Sale Amount", type: 'number', flex: 1 },
              ]
              : endpoint === "6MONTH_SALES_COMP"
                ? [
                  { field: "id", headerName: "Sl No", flex: 0.3 },
                  {
                    field: "Current6MonthsSales",
                    headerName: "Current 6 Months Sales",
                    flex: 1,
                    valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "AED",
                      minimumFractionDigits: 2,
                    }),
                  },
                  {
                    field: "Previous6MonthsSales",
                    headerName: "Previous 6 Months Sales",
                    flex: 1,
                    valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "AED",
                      minimumFractionDigits: 2,
                    }),
                  },
                  {
                    field: "GrowthPercent",
                    headerName: "Growth (%)",
                    flex: 0.7,
                    // valueFormatter: (params) => `${params.value?.toFixed(2)}%`,
                    valueFormatter: (params) => params.value?.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "AED",
                      minimumFractionDigits: 2,
                    }),
                  },
                ]
                : endpoint === "MONTH_SALES_COMP"
                  ? [
                    { field: "id", headerName: "Sl No", flex: 0.3 },
                    {
                      field: "SaleMonth",
                      headerName: "Sale Month",
                      flex: 0.8,
                    },
                    {
                      field: "SalesCount",
                      headerName: "Sales Count",
                      flex: 0.6,
                      type: "number",
                    },
                    {
                      field: "TotalSales",
                      headerName: "Total Sales",
                      flex: 1,
                      type: "number",

                      valueFormatter: (params) =>
                        params.value?.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "AED",
                          minimumFractionDigits: 2,
                        }),
                    },
                    {
                      field: "AvgSaleAmount",
                      headerName: "Avg. Sale Amount",
                      flex: 1,
                      type: "number",

                      valueFormatter: (params) =>
                        params.value?.toLocaleString("en-IN", {
                          style: "currency",
                          currency: "AED",
                          minimumFractionDigits: 2,
                        }),
                    },
                    {
                      field: "PrevMonthSales",
                      headerName: "Prev Month Sales",
                      flex: 1,
                      type: "number",

                      // valueFormatter: (params) =>
                      //   params?.value != null
                      //     ? params?.value.toLocaleString("en-IN", {
                      //       style: "currency",
                      //       currency: "AED",
                      //       minimumFractionDigits: 2,
                      //     })
                      //     : "-",
                    },
                    {
                      field: "GrowthPercent",
                      headerName: "Growth (%)",
                      flex: 0.7,
                      type: "number",

                      // valueFormatter: (params) =>
                      //   params?.value != null ? `${params?.value.toFixed(2)}%` : "-",
                    },
                  ]
                  : endpoint === "MONTH_LEAD_PIPELINE"
                    ? [
                      { field: "id", headerName: "Sl No", flex: 0.3 },
                      { field: "lead_stage", headerName: "Lead Stage", flex: 1 },
                      { field: "Leads_CurrentMonth", headerName: "Current Month Leads", flex: 1, type: "number" },
                      { field: "Leads_PreviousMonth", headerName: "Previous Month Leads", flex: 1, type: "number" },
                      {
                        field: "BookedAmt_CurrentMonth",
                        headerName: "Booked Amt (Current)",
                        flex: 1,
                        type: "number",
                        valueFormatter: (params) =>
                          params.value?.toLocaleString("en-IN", {
                            style: "currency",
                            currency: "AED",
                            minimumFractionDigits: 2,
                          }),
                      },
                      {
                        field: "BookedAmt_PreviousMonth",
                        headerName: "Booked Amt (Previous)",
                        flex: 1,
                        type: "number",
                        valueFormatter: (params) =>
                          params.value?.toLocaleString("en-IN", {
                            style: "currency",
                            currency: "AED",
                            minimumFractionDigits: 2,
                          }),
                      },
                      {
                        field: "GrowthPercent",
                        headerName: "Growth (%)",
                        flex: 0.7,
                        type: "number"
                        // valueFormatter: (params) =>
                        //   params?.value != null ? `${params?.value.toFixed(2)}%` : "-",
                      },
                    ]

                    : endpoint === "New_Client_Acquisition_6mon"
                      ? [
                        { field: "id", headerName: "Sl No", flex: 0.3 },
                        {
                          field: "Current6MonthsNewClients",
                          headerName: "New Clients (Current 6 Months)",
                          flex: 1.5,
                        },
                        {
                          field: "Current6MonthsRevenue",
                          headerName: "Revenue (Current 6 Months)",
                          flex: 1.5,
                          valueFormatter: (params) =>
                            params.value?.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "AED",
                              minimumFractionDigits: 2,
                            }),
                        },
                        {
                          field: "Previous6MonthsNewClients",
                          headerName: "New Clients (Previous 6 Months)",
                          flex: 1.5,
                        },
                        {
                          field: "Previous6MonthsRevenue",
                          headerName: "Revenue (Previous 6 Months)",
                          flex: 1.5,
                          valueFormatter: (params) =>
                            params?.value?.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "AED",
                              minimumFractionDigits: 2,
                            }),
                        },
                      ]
                      : endpoint === "Top_50_Selling_Products"
                        ? [
                          { field: "id", headerName: "Sl No", flex: 0.3 },
                          { field: "code", headerName: "Product Code", flex: 0.8 },
                          {
                            field: "desc",
                            headerName: "Product Description",
                            flex: 2.5,
                            renderCell: (params) => (
                              <div className="line-clamp-2 overflow-hidden">{params.value}</div>
                            ),
                          },
                          {
                            field: "Current6MonthsSales",
                            headerName: "Sales (Current 6 Months)",
                            flex: 1.2,
                            type: "number",
                            valueFormatter: (params) =>
                              params.value?.toLocaleString("en-IN", {
                                style: "currency",
                                currency: "AED",
                                minimumFractionDigits: 2,
                              }),
                          },
                          {
                            field: "Previous6MonthsSales",
                            headerName: "Sales (Previous 6 Months)",
                            flex: 1.2,
                            type: "number",
                            valueFormatter: (params) =>
                              params?.value?.toLocaleString("en-IN", {
                                style: "currency",
                                currency: "AED",
                                minimumFractionDigits: 2,
                              }),
                          },
                        ]
                        : endpoint === "Monthly_Expense_analysis"
                          ? [
                            { field: "id", headerName: "Sl No", flex: 0.3 },
                            { field: "account", headerName: "Account", flex: 0.8 },
                            { field: "accdesc", headerName: "Account Description", flex: 2 },
                            { field: "2025-01", headerName: "Jan 2025", flex: 0.8, type: "number" },
                            { field: "2025-02", headerName: "Feb 2025", flex: 0.8, type: "number" },
                            { field: "2025-03", headerName: "Mar 2025", flex: 0.8, type: "number" },
                            { field: "2025-04", headerName: "Apr 2025", flex: 0.8, type: "number" },
                            { field: "2025-05", headerName: "May 2025", flex: 0.8, type: "number" },
                            { field: "2025-06", headerName: "Jun 2025", flex: 0.8, type: "number" },
                            {
                              field: "Total",
                              headerName: "Total",
                              flex: 1,
                              type: "number",
                              valueGetter: (params) => {
                                // Calculate total of all months, ignoring nulls
                                const months = ["2025-01", "2025-02", "2025-03", "2025-04", "2025-05", "2025-06"];
                                return months.reduce((sum, month) => sum + (params?.row[month] ?? 0), 0);
                              },
                            },
                          ]
                          : endpoint === "Sales_Growth_Rate"
                            ? [
                              { field: "id", headerName: "Sl No", flex: 0.3 },
                              { field: "SaleMonth", headerName: "Sale Month", flex: 1 },
                              { field: "TotalSales", headerName: "Total Sales", flex: 1, type: "number" },
                              { field: "PrevMonthSales", headerName: "Previous Month Sales", flex: 1, type: "number" },
                              {
                                field: "GrowthPercent",
                                headerName: "Growth Percent (%)",
                                flex: 1,
                                type: "number",
                                // valueFormatter: (params) =>
                                //   params?.value !== null && params?.value !== undefined
                                //     ? `${params?.value.toFixed(2)}%`
                                //     : "N/A",
                              },
                            ]

                            : endpoint === "Profit_Analysis_Branch"
                              ? [
                                { field: "id", headerName: "Sl No", flex: 0.3 },
                                { field: "deptno", headerName: "Dept No", flex: 0.6 },
                                { field: "Branch", headerName: "Branch", flex: 1 },
                                { field: "Month", headerName: "Month", flex: 1 },
                                { field: "Income", headerName: "Income", flex: 1, type: "number" },
                                { field: "Expense", headerName: "Expense", flex: 1, type: "number" },
                                { field: "NetProfit", headerName: "Net Profit", flex: 1, type: "number" },
                                {
                                  field: "ProfitPercent",
                                  headerName: "Profit %",
                                  flex: 0.8,
                                  type: "number",
                                  // valueFormatter: (params) =>
                                  //   params.value !== null && params.value !== undefined
                                  //     ? `${params.value.toFixed(2)}%`
                                  //     : "N/A",
                                },
                              ]
                              : endpoint === "Profit_Analysis_Company"
                                ? [
                                  { field: "id", headerName: "Sl No", flex: 0.3 },
                                  { field: "Month", headerName: "Month", flex: 1 },
                                  { field: "Income", headerName: "Income", flex: 1, type: "number" },
                                  { field: "Expense", headerName: "Expense", flex: 1, type: "number" },
                                  { field: "NetProfit", headerName: "Net Profit", flex: 1, type: "number" },
                                  {
                                    field: "ProfitPercent",
                                    headerName: "Profit %",
                                    flex: 0.8,
                                    type: "number",
                                    // valueFormatter: (params) =>
                                    //   params.value !== null && params.value !== undefined
                                    //     ? `${params.value.toFixed(2)}%`
                                    //     : "N/A",
                                  },
                                ]
                                : endpoint === "Customer_Health_Summary"
                                  ? [
                                    { field: "id", headerName: "Sl No", flex: 0.3 },
                                    { field: "TotalActiveCustomers", headerName: "Total Active Customers", flex: 1 },
                                    { field: "NewCustomers6M", headerName: "New Customers (6M)", flex: 1 },
                                    { field: "Inactive3M", headerName: "Inactive (3M)", flex: 1 },
                                    { field: "Reactivated3M", headerName: "Reactivated (3M)", flex: 1 },
                                  ]
                                  // : endpoint === "SALES_FORCAST"
                                  //   ? [
                                  //     { field: "id", headerName: "Sl No", flex: 0.3 },
                                  //     { field: "Branch", headerName: "Branch", flex: 1 },
                                  //     { field: "Month", headerName: "Month", flex: 1 },
                                  //     { field: "ForecastSales", headerName: "Forecast Sales", flex: 1 },
                                  //     { field: "ActualSales", headerName: "Actual Sales", flex: 1 },
                                  //     { field: "AchievementPercent", headerName: "Achievement %", flex: 1 },
                                  //   ]
                                  : endpoint === "SALES_FORECAST"
                                    ? [
                                      { field: "id", headerName: "Sl No", flex: 0.3 },
                                      { field: "deptno", headerName: "Department No", flex: 1 },
                                      { field: "ForecastMonth", headerName: "Forecast Month", flex: 1 },
                                      { field: "ForecastedSales", headerName: "Forecasted Sales", flex: 1, type: "number" },
                                    ]
                                    : endpoint === "SALES_TARGET_ANALYSIS"
                                      ? [
                                        { field: "id", headerName: "Sl No", flex: 0.3 },
                                        { field: "Branch", headerName: "Branch", flex: 1 },
                                        { field: "Month", headerName: "Month", flex: 1 },
                                        { field: "ForecastSales", headerName: "Forecast Sales", flex: 1, type: "number" },
                                        { field: "ActualSales", headerName: "Actual Sales", flex: 1, type: "number" },
                                        { field: "AchievementPercent", headerName: "Achievement Percent %", flex: 1, type: "number" },
                                      ]
                                      : endpoint === "CUST_PERF_6MONTH"
                                        ? [
                                          { field: "id", headerName: "Sl No", flex: 0.3 },
                                          { field: "ACCOUNT", headerName: "Account No", flex: 1 },
                                          { field: "ACCDESC", headerName: "Account Name", flex: 2 },
                                          { field: "LastSaleDate", headerName: "Last Sale Date", flex: 1 },
                                          { field: "SalesCount", headerName: "Sales Count", flex: 1, type: "number" },
                                          { field: "TotalSales", headerName: "Total Sales", flex: 1, type: "number" },
                                          { field: "AvgSaleAmount", headerName: "Average Sale Amount", flex: 1, type: "number" },
                                        ]
                                        : endpoint === "CASHFLOW"
                                          ? [
                                            { field: "id", headerName: "Sl No", flex: 0.3 },
                                            { field: "Month", headerName: "Month", flex: 1 },
                                            {
                                              field: "CashInflow",
                                              headerName: "Cash Inflow",
                                              flex: 1,
                                              type: "number",
                                            },
                                            {
                                              field: "CashOutflow",
                                              headerName: "Cash Outflow",
                                              flex: 1,
                                              type: "number",
                                            },
                                            {
                                              field: "NetCashFlow",
                                              headerName: "Net Cash Flow",
                                              flex: 1,
                                              type: "number",
                                              cellClassName: (params) =>
                                                params.value < 0 ? "text-red-500" : "text-green-600", // Optional styling
                                            },
                                          ]
                                          : endpoint === "CRM_CUSTOMER_RETENSION"
                                            ? [
                                              { field: "id", headerName: "Sl No", flex: 0.3 },
                                              { field: "customerId", headerName: "Customer ID", flex: 2 },
                                              { field: "customerName", headerName: "Customer Name", flex: 2 },
                                              { field: "lastOrder", headerName: "Last_Order", flex: 2 },
                                              { field: "ordersCount", headerName: "OrdersCount", flex: 1, type: 'number' },
                                            ]
                                            : endpoint === "CRM_SALESMAN_PERFORM"
                                              ? [
                                                { field: "id", headerName: "Sl No", flex: 0.3 },
                                                { field: "salesmanId", headerName: "Salesman ID", flex: 2 },
                                                { field: "salesmanName", headerName: "Salesman Name", flex: 2 },
                                                { field: "totalOrders", headerName: "Total Orders", flex: 1.5 },
                                                { field: "totalRevenue", headerName: "Total Sales", flex: 1.5 },
                                              ]
                                              : endpoint === "CRM_CUSTOMER_AQUI"
                                                ? [

                                                  { field: "id", headerName: "Sl No", flex: 1 },
                                                  { field: "month", headerName: "Month", flex: 2 },
                                                  { field: "newCustomers", headerName: "New Customers", flex: 2 },
                                                ]
                                                : endpoint === "CRM_CHURN_ANALYSIS"
                                                  ? [
                                                    { field: "id", headerName: "Sl No", flex: 0.3 },
                                                    { field: "customerId", headerName: "Customer ID", flex: 1 },
                                                    { field: "customerName", headerName: "Customer Name", flex: 2 },
                                                    {
                                                      field: "lastOrder",
                                                      headerName: "Last Order",
                                                      flex: 1,
                                                      renderCell: (params) => {
                                                        const lastOrderDate = parseISO(params.value);
                                                        const today = new Date();
                                                        const daysDiff = differenceInDays(today, lastOrderDate);

                                                        let icon, color, tooltipText;

                                                        if (daysDiff < 30) {
                                                          icon = <CheckCircle sx={{ color: "green" }} />;
                                                          tooltipText = "Recent Order (Less than 30 days)";
                                                        } else if (daysDiff >= 30 && daysDiff <= 365) {
                                                          icon = <Warning sx={{ color: "orange" }} />;
                                                          tooltipText = "Medium Order (Between 1 month and 1 year)";
                                                        } else {
                                                          icon = <Error sx={{ color: "red" }} />;
                                                          tooltipText = "Old Order (More than 1 year)";
                                                        }

                                                        return (
                                                          <Tooltip title={tooltipText} arrow>
                                                            <span
                                                              style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                              }}
                                                            >
                                                              {format(lastOrderDate, "dd-MM-yyyy")} {icon}
                                                            </span>
                                                          </Tooltip>
                                                        );
                                                      },
                                                    },
                                                  ]
                                                  : [];

  const rows =
    endpoint === "CRM_TOP100ORDER_PRODUCTS"
      ? tableData
        ? tableData.map((item, index) => ({
          id: index + 1,
          code: item.code,
          desc: item.desc,
          totalRevenue: item.TotalRevenue,
          totalSold: item.TotalSold,
        }))
        : []
      : endpoint === "CRM_CUST_LIFETIME_VALUE"
        ? tableData
          ? tableData.map((item, index) => ({
            id: index + 1,
            account: item.account,
            accountDescription: item.accdesc,
            totalSpent: item.TotalSpent,
            totalOrders: item.TotalOrders,
            avgOrderValue: item.AvgOrderValue,
          }))
          : []


        : endpoint === "DAILYSALES_DEPT"
          ? tableData
            ? tableData.map((item, index) => ({
              id: index + 1,
              deptno: item.deptno,
              deptnodesc: item.deptnodesc,
              // SaleDate: item.SaleDate,
              SaleDate: new Date(item.SaleDate).toLocaleDateString('en-GB'),
              SalesCount: item.SalesCount,
              TotalSales: item.TotalSales,
              AvgOrderValue: item.AvgOrderValue,
            }))
            : []
          : endpoint === "MONTHLYSALES_DEPT"
            ? tableData
              ? tableData.map((item, index) => ({
                id: index + 1,
                deptno: item.deptno,
                deptnodesc: item.deptnodesc,
                SaleMonth: item.SaleMonth,
                SalesCount: item.SalesCount,
                TotalSales: item.TotalSales,
                AvgOrderValue: item.AvgOrderValue,
              }))
              : []
            : endpoint === "SAMAN_PERF_SUMM"
              ? tableData
                ? tableData.map((item, index) => ({
                  id: index + 1,
                  sman_key: item.sman_key,
                  sman_name: item.sman_name,
                  SalesCount: item.SalesCount,
                  TotalSales: item.TotalSales,
                  // LastSaleDate: item.LastSaleDate,
                  LastSaleDate: new Date(item.LastSaleDate).toLocaleDateString(), // format to local date string

                  AvgSaleAmount: item.AvgSaleAmount,
                  email: item.email,
                  phoneno: item.phoneno,
                }))
                : []
              : endpoint === "6MONTH_SALES_COMP"
                ? tableData
                  ? tableData.map((item, index) => ({
                    id: index + 1,
                    Current6MonthsSales: item.Current6MonthsSales,
                    Previous6MonthsSales: item.Previous6MonthsSales,
                    GrowthPercent: item.GrowthPercent,
                  }))
                  : []

                : endpoint === "MONTH_SALES_COMP"
                  ? tableData
                    ? tableData.map((item, index) => ({
                      id: index + 1,
                      SaleMonth: item.SaleMonth,
                      SalesCount: item.SalesCount,
                      TotalSales: item.TotalSales,
                      AvgSaleAmount: item.AvgSaleAmount,
                      PrevMonthSales: item.PrevMonthSales,
                      GrowthPercent: item.GrowthPercent,
                    }))
                    : []
                  : endpoint === "MONTH_LEAD_PIPELINE"
                    ? tableData
                      ? tableData.map((item, index) => ({
                        id: index + 1,
                        lead_stage: item.lead_stage,
                        Leads_CurrentMonth: item.Leads_CurrentMonth,
                        Leads_PreviousMonth: item.Leads_PreviousMonth,
                        BookedAmt_CurrentMonth: item.BookedAmt_CurrentMonth,
                        BookedAmt_PreviousMonth: item.BookedAmt_PreviousMonth,
                        GrowthPercent: item.GrowthPercent,
                      }))
                      : []
                    : endpoint === "New_Client_Acquisition_6mon"
                      ? tableData
                        ? tableData.map((item, index) => ({
                          id: index + 1,
                          Current6MonthsNewClients: item.Current6MonthsNewClients,
                          Current6MonthsRevenue: item.Current6MonthsRevenue,
                          Previous6MonthsNewClients: item.Previous6MonthsNewClients,
                          Previous6MonthsRevenue: item.Previous6MonthsRevenue,
                        }))
                        : []
                      : endpoint === "Top_50_Selling_Products"
                        ? tableData
                          ? tableData.map((item, index) => ({
                            id: index + 1,
                            code: item.code,
                            desc: item.desc,
                            Current6MonthsSales: item.Current6MonthsSales,
                            Previous6MonthsSales: item.Previous6MonthsSales,
                          }))
                          : []
                        : endpoint === "Monthly_Expense_analysis"
                          ? tableData
                            ? tableData.map((item, index) => ({
                              id: index + 1,
                              account: item.account,
                              accdesc: item.accdesc.trim(),
                              "2025-01": item["2025-01"] ?? 0,
                              "2025-02": item["2025-02"] ?? 0,
                              "2025-03": item["2025-03"] ?? 0,
                              "2025-04": item["2025-04"] ?? 0,
                              "2025-05": item["2025-05"] ?? 0,
                              "2025-06": item["2025-06"] ?? 0,
                              Total: null, // Total will be calculated in valueGetter of column
                            }))
                            : []
                          : endpoint === "Sales_Growth_Rate"
                            ? tableData
                              ? tableData.map((item, index) => ({
                                id: index + 1,
                                SaleMonth: item.SaleMonth,
                                TotalSales: item.TotalSales,
                                PrevMonthSales: item.PrevMonthSales ?? 0,
                                GrowthPercent: item.GrowthPercent,
                              }))
                              : []
                            : endpoint === "Profit_Analysis_Branch"
                              ? tableData
                                ? tableData.map((item, index) => ({
                                  id: index + 1,
                                  deptno: item.deptno,
                                  Branch: item.Branch,
                                  Month: item.Month,
                                  Income: item.Income,
                                  Expense: item.Expense,
                                  NetProfit: item.NetProfit,
                                  ProfitPercent: item.ProfitPercent,
                                }))
                                : []
                              : endpoint === "Profit_Analysis_Company"
                                ? tableData
                                  ? tableData.map((item, index) => ({
                                    id: index + 1,
                                    Month: item.Month,
                                    Income: item.Income,
                                    Expense: item.Expense,
                                    NetProfit: item.NetProfit,
                                    ProfitPercent: item.ProfitPercent,
                                  }))
                                  : []
                                : endpoint === "Customer_Health_Summary"
                                  ? tableData
                                    ? tableData.map((item, index) => ({
                                      id: index + 1,
                                      TotalActiveCustomers: item["Total Active Customers"],
                                      NewCustomers6M: item["New Customers (6M)"],
                                      Inactive3M: item["Inactive (3M)"],
                                      Reactivated3M: item["Reactivated (3M)"],
                                    }))
                                    : []
                                  // : endpoint === "SALES_FORCAST"
                                  //   ? tableData
                                  //     ? tableData.map((item, index) => ({
                                  //       id: index + 1,
                                  //       Branch: item.Branch,
                                  //       Month: item.Month,
                                  //       ForecastSales: item.ForecastSales,
                                  //       ActualSales: item.ActualSales,
                                  //       AchievementPercent: item.AchievementPercent,
                                  //     }))
                                  : endpoint === "SALES_FORECAST"
                                    ? tableData
                                      ? tableData.map((item, index) => ({
                                        id: index + 1,
                                        deptno: item.deptno,
                                        ForecastMonth: item.ForecastMonth,
                                        ForecastedSales: item.ForecastedSales,
                                      }))
                                      : []
                                    : endpoint === "SALES_TARGET_ANALYSIS"
                                      ? tableData
                                        ? tableData.map((item, index) => ({
                                          id: index + 1,
                                          Branch: item.Branch,
                                          Month: item.Month,
                                          ForecastSales: item.ForecastSales,
                                          ActualSales: item.ActualSales,
                                          AchievementPercent: item.AchievementPercent,
                                        }))
                                        : []
                                      : endpoint === "CUST_PERF_6MONTH"
                                        ? tableData
                                          ? tableData.map((item, index) => ({
                                            id: index + 1,
                                            ACCOUNT: item.ACCOUNT,
                                            ACCDESC: item.ACCDESC,
                                            LastSaleDate: new Date(item.LastSaleDate).toLocaleDateString(), // format to local date string
                                            SalesCount: item.SalesCount,
                                            TotalSales: item.TotalSales.toFixed(2),
                                            AvgSaleAmount: item.AvgSaleAmount.toFixed(2)
                                          }))
                                          : []
                                        : endpoint === "CASHFLOW"
                                          ? tableData
                                            ? tableData.map((item, index) => ({
                                              id: index + 1,
                                              Month: item.Month,
                                              CashInflow: item.CashInflow,
                                              CashOutflow: item.CashOutflow,
                                              NetCashFlow: item.NetCashFlow,
                                            }))
                                            : []
















                                          : endpoint === "CRM_CUSTOMER_RETENSION"
                                            ? tableData
                                              ? tableData.map((item, index) => ({
                                                id: index + 1,
                                                customerId: item.CustomerID,
                                                customerName: item.CustomerName,
                                                // lastOrder: item.Last_Order,

                                                lastOrder: new Date(item.Last_Order).toLocaleDateString('en-GB'), // format to local date string

                                                ordersCount: item.OrdersCount,
                                              }))
                                              : []
                                            : endpoint === "CRM_CHURN_ANALYSIS"
                                              ? tableData
                                                ? tableData.map((item, index) => ({
                                                  id: index + 1,
                                                  customerId: item.CustomerID,
                                                  customerName: item.CustomerName,
                                                  lastOrder: item.Last_Order,
                                                }))
                                                : []
                                              : endpoint === "CRM_SALESMAN_PERFORM"
                                                ? tableData
                                                  ? tableData.map((item, index) => ({
                                                    id: index + 1,
                                                    salesmanId: item.SalespersonID,
                                                    salesmanName: item.SalespersonName,
                                                    totalOrders: item.TotalOrders,
                                                    totalRevenue: item.TotalSales,
                                                  }))
                                                  : []
                                                : endpoint === "CRM_CUSTOMER_AQUI"
                                                  ? tableData
                                                    ? tableData.map((item, index) => ({
                                                      id: index + 1,
                                                      month: item.Month,
                                                      newCustomers: item.NewCustomers,
                                                    }))
                                                    : []
                                                  : [];

  return (
    <div className="w-full overflow-x-auto">

      {(rows && columns) ?
        <Paper sx={{ minWidth: 600, height: 400 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            checkboxSelection
            pagination
            paginationMode="server"
            page={page}
            pageSizeOptions={[pageSize]}
            rowCount={rows.length}
            onPageChange={(newPage) => setPage(newPage)}
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeader": {
                fontFamily: "'Figtree', sans-serif",
                background: "#27446A",
                color: "#F8F8F8",
              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                color: "#FFFFFF", // hide the "Select All" label space
              },
              "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                color: "#FFFFFF", // unselected checkbox color
              },
              "& .MuiDataGrid-columnHeaderCheckbox .Mui-checked": {
                color: "#FFFFFF", // selected checkbox color
              },
              "& .MuiDataGrid-cell": {
                padding: "1px 2px",
                fontFamily: "'Figtree', sans-serif",
              },
            }}
          />
        </Paper>

        :
        <div>No data found</div>
      }
    </div>

  );
};

export default DataTable;